
import { PageRequest } from "@/store/shared/entity";
import {
  Component,
  Mixins,
  ActionButtonConfig,
  PageResultBaseMixins,
  PageResultListMixins,
  appConst,
  $util
} from "@/lib";

class PageOverdueRequest extends PageRequest {
   shipmentDate: string[];
   ownerId: number;
   businessGroup: string;
   customerId: number;
   salesType: string;
   deadline: string;
   daysStart: number = null;
   daysEnd: number = null;
   constructor() {
     super();
     this.deadline = $util.format.date(Date.now());
     this.salesType = appConst.salesType.exportSales;// 默认出口
   }
}

@Component({ name: "overdue.list" })
export default class OverdueView extends Mixins(PageResultBaseMixins, PageResultListMixins) {
  
  data: any = {
    model: new PageOverdueRequest(),
    queryAction: "foreignexchangecollection/overdue/getAll",
    isAutoQuery: true,
    cols: this.resultColumns,
  };

  //清除查询条件  重新加载数据
  reset() {
    this.data.model = new PageOverdueRequest();
    // 不是业务组负责人，则默认查询单证为当前人
    if (!this.businessGroupOfCurrentUser) {
      if (this.userList && this.userList.findIndex(item => item.value === this.currentUser.id) > -1) {
        this.$set(this.data.model, "ownerId", this.currentUser.id);
      }
    } else {
      if (this.businessGroupList && this.businessGroupList.findIndex(item => item.value === this.businessGroupOfCurrentUser) > -1) {
        this.$set(this.data.model, "businessGroup", this.businessGroupOfCurrentUser);
      }
    }
  }

  get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
  // 当前人负责的业务组
  get businessGroupOfCurrentUser() {
    return this.$store.state.system.user.businessGroup;
  }

  // 单证列表
  get userList() {
    return this.$store.state.system.userassignment.userList;
  }

  //客户列表
  get customerList() {
    return this.$store.state.system.customer.customerList;
  }

  // 业务组列表
  get businessGroupList() {
    return this.getCodeListByCategory(appConst.codeCategory.businessGroup)
  }

  // 销售类型列表
  get salesTypeList() {
    return this.getCodeListByCategory(appConst.codeCategory.salesType)
  }

  get salesTypeText() {
    return this.data.model.salesType == appConst.salesType.domesticSales ? "￥" : "$";
  }

  get totalOverdueAmount() {
    const text = this.L("app.Overdue.OverdueAmountTitle");
    let amount = this.$util.format.amount(this.$store.state.foreignexchangecollection.overdue.totalOverdueAmount);
    return `${text}${this.salesTypeText}${amount}`;
  }

  get resultColumns() {
    return [
      {
        title: this.L("app.DeclareCustoms.BusinessGroup"),
        key: "businessGroup",
        minWidth: 80,
        maxWidth: 100,
        tooltip: true
      },
      {
        title: this.L("app.DeclareCustoms.Document"),
        key: "ownerName",
        minWidth: 100,
        tooltip: true
      },
      {
        title: this.L("app.DeclareCustoms.CustomerName"),
        key: "customerName",
        minWidth: 250,
        tooltip: true
      },
      {
        title: this.L("app.DeclareCustoms.ShippingNumber"),
        key: "shippingNumber",
        minWidth: 120
      },
      this.$util.render.dateColumn("app.DeclareCustoms.ShipmentDate", "shipmentDate"),
      {
        title: this.L("app.Overdue.OverdueAmount"),
        key: "overdueAmount",
        minWidth: 100,
        maxWidth: 160,
        render: (h: any, params: any) => {
          if (!params.row.overdueAmount) {
            return [h("span", 'NA')];
          }
          return [h("span", `${this.salesTypeText}${this.$util.format.amount(params.row.overdueAmount)}`)];
        },
      },
      {
        title: this.L("app.DeclareCustoms.Payment"),
        key: "payment",
        minWidth: 120,
        maxWidth: 180,
      },
      this.$util.render.dateColumn("app.Income.PrePaymentDate.PrePaymentDate", "prePaymentDate"),
      {
        title: this.L("app.Overdue.OverdueDays"),
        key: "overdueDays",
        width: 100
      }
    ];
  }

  get setOverdueDays() {
    return {
      start: {
        max: this.data.model.daysEnd ? this.data.model.daysEnd : 9999999
      },
      end: {
        min: !!this.data.model.daysStart ? this.data.model.daysStart : 1
      }
    }
  }
  
  async created() {
    // 不是业务组负责人，则默认查询单证为当前人
    if (!this.businessGroupOfCurrentUser) {
      if (this.userList && this.userList.findIndex(item => item.value === this.currentUser.id) > -1) {
        this.$set(this.data.model, "ownerId", this.currentUser.id);
      }
    } else {
      if (this.businessGroupList && this.businessGroupList.findIndex(item => item.value === this.businessGroupOfCurrentUser) > -1) {
        this.$set(this.data.model, "businessGroup", this.businessGroupOfCurrentUser);
      }
    }
  }

  async activated() {
    await this.$store.dispatch({type:'system/userassignment/getUser'});
  }
}
